import { FaSearch, FaCalendarAlt, FaCreditCard, FaSmile } from "react-icons/fa";

const steps = [
  {
    icon: <FaSearch className="text-orange-500 text-xl" />,
    title: "Find What You Need",
    description:
      "Browse through our curated selection of deals, services, and activities in your area",
  },
  {
    icon: <FaCalendarAlt className="text-orange-500 text-xl" />,
    title: "Book & Schedule",
    description:
      "Choose your preferred time slot and make a reservation in just a few clicks",
  },
  {
    icon: <FaCreditCard className="text-orange-500 text-xl" />,
    title: "Easy Payment",
    description:
      "Secure payment options with instant confirmation and booking details",
  },
  {
    icon: <FaSmile className="text-orange-500 text-xl" />,
    title: "Enjoy & Review",
    description:
      "Experience great services and share your feedback with the community",
  },
];

export default function HowItWorks() {
  return (
    <div className="bg-gray-50 py-10 px-4 sm:px-6 lg:px-8 text-center">
      <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
        How It Works
      </h2>
      <p className="text-sm sm:text-base text-gray-600 mb-10 max-w-xl mx-auto">
        Getting started is easy! Follow these simple steps to discover and book
        amazing local services and activities.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 max-w-6xl mx-auto">
        {steps.map((step, index) => (
          <div
            key={index}
            className="flex flex-col items-center text-center space-y-3 px-4"
          >
            <div className="bg-white shadow-md rounded-full p-4">
              {step.icon}
            </div>
            <h3 className="font-semibold text-sm sm:text-base text-gray-800">
              {step.title}
            </h3>
            <p className="text-xs sm:text-sm text-gray-500">
              {step.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
